import { render } from "./FixedFeePrices.vue?vue&type=template&id=0b04663c&scoped=true"
import script from "./FixedFeePrices.vue?vue&type=script&lang=js"
export * from "./FixedFeePrices.vue?vue&type=script&lang=js"

import "./FixedFeePrices.vue?vue&type=style&index=0&id=0b04663c&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b04663c"]])

export default __exports__